import * as React from "react";
const SvgFiRrTruckBox = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-truck-box_svg__a)">
      <path
        fill="#062147"
        d="M19 6h-2.113A5 5 0 0 0 14.5 2.67a.999.999 0 1 0-1.001 1.73 3.01 3.01 0 0 1 1.5 2.6v11H4c-1.103 0-2-.897-2-2v-3a1 1 0 1 0-2 0v3c0 1.881 1.309 3.452 3.061 3.877A3.4 3.4 0 0 0 3 20.5C3 22.43 4.57 24 6.5 24s3.5-1.57 3.5-3.5c0-.169-.017-.335-.041-.5h4.082a3.5 3.5 0 0 0-.041.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5a3.5 3.5 0 0 0-.061-.623C22.691 19.452 24 17.881 24 16v-5c0-2.757-2.243-5-5-5m3 5v1h-5V8h2c1.654 0 3 1.346 3 3M8 20.5c0 .827-.673 1.5-1.5 1.5S5 21.327 5 20.5c0-.189.039-.355.093-.5h2.815c.054.145.093.311.093.5zm9.5 1.5c-.827 0-1.5-.673-1.5-1.5 0-.189.039-.355.093-.5h2.815c.054.145.093.311.093.5 0 .827-.674 1.5-1.501 1.5m2.5-4h-3v-4h5v2c0 1.103-.897 2-2 2M3 10h5c1.654 0 3-1.346 3-3V3c0-1.654-1.346-3-3-3H3C1.346 0 0 1.346 0 3v4c0 1.654 1.346 3 3 3M2 3c0-.552.449-1 1-1h5c.551 0 1 .448 1 1v4c0 .552-.449 1-1 1H3c-.551 0-1-.448-1-1zm2 1a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-truck-box_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTruckBox;
